module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_3009.a66b0e5f.png";